import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { InputTextModule } from 'primeng/inputtext';
import { PersonaClientesService } from "../../servicios/persona-clientes.service";
import { CatEstadosService } from "../../servicios/cat-estados.service";
import { CatMunicipiosService } from "../../servicios/cat-municipios.service";
import { CatColoniasService } from "../../servicios/cat-colonias.service";
import { CatCallesService } from "../../servicios/cat-calles.service";
import { CatTipoPersonasService } from "../../servicios/cat-tipo-personas.service";
import { CatRegimenFiscalService} from "../../servicios/cat-regimen-fiscal.service"
import { CatCfdiUsosService } from 'app/servicios/cat-cfdi-usos.service';
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { PersonaClientes,BuscaPersonaClientes, CatEstados, CatMunicipios, CatColonias, CatTipoPersonas, CatCalles,CatRegimenFiscal, CatDelegaciones, CuentasByPersona, CatCfdiUsos } from "../../entidades/entidades";
import { ConfirmationService, MenuItem } from 'primeng/api';
import { BuscaPersonaClientesService } from "../../servicios/busca-persona-clientes.service";
import { SolicitudesService } from "../../servicios/solicitudes.service";
import { Dropdown } from "primeng/dropdown";
import { CatDelegacionesService } from "../../servicios/cat-delegaciones.service";

declare var $: any;

//CAMBIO
@Component({
  selector: "app-persona-clientes",
  templateUrl: "./persona-clientes.component.html",
  styleUrls: ["./persona-clientes.component.css"],
})
export class PersonaClientesComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catEstados: CatEstados[] = [];
  catMunicipios: CatMunicipios[] = [];
  catDelegaciones: CatDelegaciones[] = [];
  catColonias: CatColonias[] = [];
  catCalles: CatCalles[] = [];
  catTipoPersonas: CatTipoPersonas[] = [];
  regimenFiscal= new CatRegimenFiscal();
  catRegimenFiscal:CatRegimenFiscal[] = [];
  cfdiUsos = new CatCfdiUsos();
  catCfdiUsos: CatCfdiUsos[] = [];

  cuentasAguas: CuentasByPersona[] = [];
  columnasTabla: any[];
  itemsMenu: MenuItem[];

  datosEnvia = new PersonaClientes();
  datosRetorna = new BuscaPersonaClientes();

  DatosPersonaClientesTable: any[] = [];
  datosEnviaClientes = new PersonaClientes();
  auxColonias: number;
  auxDelegacion: number;
  auxCalle: number;
  auxEntreCalle: number;
  auxYCalle: number; 
  @ViewChild('dropDownColonia')  dropDownColonia: Dropdown;
  @ViewChild('dropDownDelegacion')  dropDownDelegacion: Dropdown;
  @ViewChild('dropDownCalle')  dropDownCalle: Dropdown;

  disableForm = false;
  valEdit = false;
  valEditPerson;
  disableSave = false;
  selectedValue: string = '1';

  showDialogCat = false;
  valueToEdit: any;
  catType: any;
  buscando: boolean = false;

  personaClientesForm: FormGroup;
  @Input("esDatosFiscales") esDatosFiscales: boolean = false;
  @Input() esVentanilla: boolean = false;
  @Input("personaClientes") personaClientes: PersonaClientes;
  @Output("personaClientesOutput") personaClientesOutput: EventEmitter<
    PersonaClientes
  >;
  tableWidget: any;
  opcionInicial: CatDelegaciones;
  coloniaSelect: CatColonias;
  calleSelect: CatCalles;
  entreCalleSelect: CatCalles;
  yCalleSelect: CatCalles;

  clonedCuentasByPersona: { [s: string]: CuentasByPersona } = {};
  constructor(
    private formBuilder: FormBuilder,
    private personaClientesService: PersonaClientesService,
    private catEstadosService: CatEstadosService,
    private catMunicipiosService: CatMunicipiosService,
    private catColoniasService: CatColoniasService,
    private catCallesService: CatCallesService,
    private catTipoPersonasService: CatTipoPersonasService,
    private buscaPersonaClientesService: BuscaPersonaClientesService,
    private catRegimenFiscalService:CatRegimenFiscalService,
    private catCfdiUsosService : CatCfdiUsosService,
    private solicitudesService: SolicitudesService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private catDelegacionesService: CatDelegacionesService,

  ) {
    this.personaClientesOutput = new EventEmitter();
  }

  ngOnInit() {

    this.columnasTabla = [
      { field: "operacion", header: "Editar", ordenar: false, styleHeader: "width: 30px;" },
      { field: "cuentaAgua", header: "Descripcion", ordenar: true, styleHeader: "width: 150px;", },
      { field: "acciones", header: "Eliminar", ordenar: false, styleHeader: "width: 30px;", },
    ];

    this.itemsMenu = [
      { label: "Agregar", icon: "pi pi-file-o", command: () => this.add(), },
      //{ label: "Guardar", icon: "pi pi-save", command: (event) => { this.guardarGridCatColonias(); } },
      //{ label: "Refrescar", icon: "pi pi-refresh", command: (event) => { this.getAllCatColonias(); } },
    ];

    this.catColonias = null;
    this.catCalles = null;
    this.catDelegaciones = null;
    //this.getAllCatEstados();
    //this.getAllCatMunicipios();
    this.getAllCatColonias();
    this.getAllCatCalles();
    //this.getAllCatDelegaciones();
    this.getAllCatTipoPersonas();
    this.getAllRegimenFiscal();
    this.getAllCfdiUsos();
    this.personaClientesForm = this.formBuilder.group({
      id: [0],
      razonSocial: [null, [Validators.maxLength(200)]],
      nombre: [undefined, [Validators.maxLength(230)]],
      primerApellido: [undefined, [Validators.maxLength(60)]],
      segundoApellido: [undefined, [Validators.maxLength(60)]],
      correoElectronico:[undefined, [Validators.maxLength(50), Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)]],
      domicilio: [undefined, ],
      rfc: [undefined, [this.validarRFC]],
      telefono: [undefined,  [Validators.pattern(/^[0-9]*$/)]],
      folioIdentificacion: [undefined, [Validators.maxLength(20)]],
      idTipoPersona: [1],
      idRegimenFiscal:[0],
      idUsoCfdi:[0],
      cp: [undefined, [Validators.pattern(/^[0-9]*$/)]],
      numExterior:[undefined, ],
      numInterior: [undefined, ],
      idColonia: null,
      idCalle: null,
      idEntreCalle: null,
      idDelegacion: null,
      DelegacionSeleccionada: null,
      ColoniaSelecionada : null,
      CalleSeleccionada:null,
      EntreCalleSeleccionada:null,
      idAgua:null,
      cuentaAgua:null,
      idYCalle: null,
    });
    if (this.personaClientes) {
      this.personaClientesForm.patchValue(this.personaClientes);
    }
    this.valEditPerson = true;
  }
  // tslint:disable-next-line: use-life-cycle-interface

  //====================================================
  //Función de muestra.
  //====================================================
  async guardarPersonaClientes() {
    try {
      if (this.personaClientesForm.invalid) {
        throw new Error("No paso las validaciones.");
      }
      
      this.personaClientes = this.personaClientesForm.value;
      this.personaClientesForm.patchValue({
        razonSocial: "XAXX010101000",
        idDelegacion : this.auxDelegacion,
        idColonia: this.auxColonias,
        idCalle:this.auxCalle,
        idEntreCalle: this.auxEntreCalle
      });
      
      if (this.personaClientes.id) {
        this.updatePersonaClientes();
      } else {
        this.personaClientes.id = 0;
        await this.addPersonaClientes();
      }
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarPersonaClientes");
    }
  }

  //====================================================
  //BuscaPersonaClientes()Funcion
  //====================================================
  async buscaPersonaClientes() {
    if (this.buscando) {
      return;
    }
    try {
      let aux = this.personaClientesForm.value.idTipoPersona;
      /////Se comprueba si el idTipoPersona si es String se cambia a Number
      /////Esto para ponerlo default
      if (typeof (aux) == "string") {
        this.personaClientesForm.patchValue({
          razonSocial: null,
          idTipoPersona: 1,
          idColonia : this.auxColonias,
        });
      }
      this.personaClientesForm.patchValue({
        idColonia : this.auxColonias,
        idCalle: this.auxCalle,
        idEntreCalle: this.auxEntreCalle,
        idDelegacion: this.auxDelegacion,
        
      });
      this.buscando = true;
      this.datosEnvia = this.personaClientesForm.value;
      this.datosEnvia.id = 0;
      this.datosEnvia.idAgua = this.personaClientesForm.value.cuentaAgua;

      debugger;      

      const datoretorno = await this.buscaPersonaClientesService
        .add(this.datosEnvia)
        .toPromise();
      this.reInitDatatable();

      
      if (Object.keys(datoretorno).length != 0) {
        const num = Object.keys(datoretorno);
        await this.DatosPersonaClientesTable.splice(0);
        for (let i = 0; i < num.length; i++) {
          this.DatosPersonaClientesTable.push(datoretorno[i]);
        }
        this.muestraMensaje.notification(
          "Registro(s) Encontrado(s).",
          "top",
          "center"
        );

      } else {
        this.DatosPersonaClientesTable.splice(0);
        this.muestraMensaje.error(
          "No hay registros disponibles.",
          "top",
          "center"
        );
      }

    } catch (error) {
      throw error;
    } finally {

      this.buscando = false;
    }
  }

  async seleccionaRow(index: number, row: any) {
    try {
      const id = row.id;
      const datoRetorno = await this.personaClientesService
        .getSingle(id)
        .toPromise();
        ;
        
         //CARGAR LAS CUENTAS DE AGUA RELACCIOANDAS A LA PERSONA CLIENTE 
        await this.getCuentasbyIdPersona(datoRetorno.id);
        if(datoRetorno.idDelegacion){
          this.opcionInicial = this.catDelegaciones.find(delegacion => delegacion.id === datoRetorno.idDelegacion);
          if (this.opcionInicial) {
          await this.selectCatDelegaciones(this.opcionInicial);
          }
        }
        
        if(datoRetorno.idColonia){
              this.coloniaSelect  = this.catColonias.find(x => x.id === datoRetorno.idColonia);
              this.auxColonias =  datoRetorno.idColonia ;
              this.personaClientesForm.patchValue({
                idColonia: this.auxColonias
              });
        }
        if(datoRetorno.idCalle){
              this.calleSelect  = this.catCalles.find(x => x.id === datoRetorno.idCalle);
              if (this.calleSelect) {
                await this.selectCatCalles(this.calleSelect);
              }
          }
          if(datoRetorno.idEntreCalle){
            this.entreCalleSelect  = this.catCalles.find(x => x.id === datoRetorno.idEntreCalle);
            this.auxEntreCalle =  datoRetorno.idEntreCalle ;
            this.personaClientesForm.patchValue({
              idEntreCalle: this.auxEntreCalle
            });
            if (this.calleSelect) {
              await this.selectCatEntreCalles(this.auxEntreCalle);
            }
      }

          
      this.personaClientesForm.reset();
      this.personaClientesForm.patchValue({
        DelegacionSeleccionada : this.opcionInicial,
        ColoniaSelecionada : this.coloniaSelect,
        CalleSeleccionada : this.calleSelect,
        EntreCalleSeleccionada: this.entreCalleSelect,
      }) 
      await this.personaClientesForm.patchValue(datoRetorno);

      this.personaClientesOutput.emit(datoRetorno);
      this.disableForm = true;
      this.disableSave = true;
      $('#mPersonaClientes').modal('hide');
    } catch (error) {
      throw error;
    }
  }
  add() {
    let cuentasByPersonaNew = new CuentasByPersona();
    cuentasByPersonaNew.cambio = true;
    cuentasByPersonaNew.id = 0;
    cuentasByPersonaNew.idPersona = this.personaClientesForm.value.id;
    cuentasByPersonaNew.numRow = this.cuentasAguas.length + 1;
    this.cuentasAguas.unshift(cuentasByPersonaNew);
  }

  async guardarGridCuentasByPersona(){
    try {
      for (let cuentasByPersona of this.cuentasAguas) {
        if (cuentasByPersona.baja) {
          await this.deleteCuentasByPersona(cuentasByPersona);
        } else if (cuentasByPersona.cambio) {
          cuentasByPersona.cambio = false;
          if (cuentasByPersona.id === 0) {
            const datoRetorno = await this.addCuentasByPersona(cuentasByPersona);
            debugger; 
            if (datoRetorno?.id === 0) {
              cuentasByPersona.cambio = true;
              this.muestraMensaje.error("El contrato" + cuentasByPersona.cuentaAgua + " no existe", "top", "center");
            }
            //cuentasByPersona.id = datoRetorno.id;
          } else {
            await this.updateCuentasByPersona(cuentasByPersona);
          } 
        }
      }
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarGridCatColonias");
    }
  }
  async deleteCuentasByPersona(cuentasByPersona: CuentasByPersona) {
    try {
      await this.personaClientesService
        .deleteCuentaAgua(cuentasByPersona.id)
        .toPromise();
      await this.getCuentasbyIdPersona(this.personaClientesForm.value.id);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCuentasByPersona");
    }
  }
  async addCuentasByPersona(cuentasByPersona) {
    try {
      const datoretorno = await this.personaClientesService
        .addCuentaAgua(cuentasByPersona)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCuentasByPersona");
    }
  }
  async updateCuentasByPersona(cuentasByPersona) {
    try {
      const datoretorno = await this.personaClientesService
        .updateCuentaAgua(cuentasByPersona)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCuentasByPersona");
    }
  }
  async onEditComplete(event) {
    try {
      let cuentasByPersonaEdit = event.data;
      //valida si hay campbio
      if(
        cuentasByPersonaEdit.id === this.clonedCuentasByPersona[cuentasByPersonaEdit.numRow].id &&
        cuentasByPersonaEdit.cuentaAgua === this.clonedCuentasByPersona[cuentasByPersonaEdit.numRow].cuentaAgua
      ){
        let index = this.cuentasAguas.findIndex((obj) => obj.numRow === cuentasByPersonaEdit.numRow);
        this.cuentasAguas[index] = { ...this.clonedCuentasByPersona[cuentasByPersonaEdit.numRow] };
        return;
      }
      cuentasByPersonaEdit.cambio = true;
      cuentasByPersonaEdit.baja = false;
    
    } catch (e) {
        this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  onEditInit(event) {
    let cuentasByPersonaEdit = event.data;
    this.clonedCuentasByPersona[cuentasByPersonaEdit.numRow] = { ...cuentasByPersonaEdit };
    cuentasByPersonaEdit.cambio = true; 
    cuentasByPersonaEdit.baja = false;  
  } 
  onDelete(event, index: number) {
    event.cambio = true;
    event.baja = true;
  }

  async getCuentasbyIdPersona(idPersona) 
  {
    try{
      const datoRetorno = await this.personaClientesService
        .getCuentaAgua(idPersona)
        .toPromise();
        this.cuentasAguas = [];

         // Iterar sobre el arreglo de números (datoRetorno)
        datoRetorno.forEach(element => {
          // Crear un objeto CuentasByPersona para cada cuenta
          const cuentaByPersona = new CuentasByPersona();
          cuentaByPersona.cuentaAgua = element.cuentaAgua;
          cuentaByPersona.id = element.id; 
          cuentaByPersona.idPersona = element.idPersona;
          this.cuentasAguas.push(cuentaByPersona);
        });

        for (var i = 0, len = this.cuentasAguas.length; i < len; i++) {
          this.cuentasAguas[i].numRow = i;
          this.clonedCuentasByPersona[this.cuentasAguas[i].numRow] = { ...this.cuentasAguas[i], };
        }

      } catch (e) {
        throw { message: e };
      } finally {
        console.log("Paso por getCatUsoCfdi");
      }
  }
  //selecciona change regimen fiscal
  async selectRegimenFiscal() {
    const idRegimenFiscal = this.personaClientesForm.controls.id.value;
    this.regimenFiscal = this.catRegimenFiscal.find((x) => x.id === idRegimenFiscal);
  }
  async selectUsosCfdi() {
    const idUsoCfdi = this.personaClientesForm.controls.id.value;
    this.cfdiUsos = this.catCfdiUsos.find((x) => x.id === idUsoCfdi);
  }
  

  //llenado de group select
  async getAllRegimenFiscal() {
    try {
      const datoRetorno = await this.catRegimenFiscalService.getAll().toPromise();
      this.catRegimenFiscal = datoRetorno;
    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por getCatUsoCfdi");
    }
  }
  async getAllCfdiUsos() {
    try {
      const datoRetorno = await this.catCfdiUsosService.getAll().toPromise();
      this.catCfdiUsos = datoRetorno;
    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por getCatUsoCfdi");
    }
  }

  

  limpiaCasillas($event) {
    this.cuentasAguas = [];
    this.clonedCuentasByPersona = {} = {};
    this.personaClientesForm.reset();
    this.personaClientesForm.patchValue({
      id: 0,
    });
    this.DatosPersonaClientesTable.splice(0);
    this.disableForm = false;
    this.valEdit = false;
    this.valEditPerson = Boolean;
    this.personaClientesForm.patchValue({
      razonSocial: null,
      idTipoPersona: 1,
      idAgua : null
    });
    this.valEditPerson = true;
   
    this.dropDownColonia.clear($event);
    this.dropDownCalle.clear($event);
    this.dropDownDelegacion.clear($event);
    this.auxColonias = null;
    this.auxCalle = null;
    this.auxEntreCalle = null;
    this.auxEntreCalle = null;
    this.auxDelegacion = null;
    //this.getAllCatDelegaciones();
     
  }

  condicionalP() {
    if (this.personaClientesForm.value.idTipoPersona == "1") {
      this.personaClientesForm.patchValue({
        razonSocial: null,
        idTipoPersona: 1
      });
      this.valEditPerson = true;
    } else
      if (this.personaClientesForm.value.idTipoPersona == "2") {
        this.personaClientesForm.patchValue({
          nombre: null,
          primerApellido: null,
          segundoApellido: null,
          idTipoPersona: 2
        });
        this.valEditPerson = false;
      }
    this.reInitDatatable();
    this.DatosPersonaClientesTable.splice(0);
  }

  condicionalEdita() {
    if (
      this.valEdit == false &&
      this.personaClientesForm.value.id != null &&
      this.personaClientesForm.value.id != 0
    ) {
      this.valEdit = true;
      this.disableForm = false;
      this.condicionalP();

    } else {
      this.muestraMensaje.error(
        "Selecciona un Cliente Primero.",
        "top",
        "center"
      );
    }
  }

  validateFormFields(): boolean {
    const { nombre, primerApellido, razonSocial, idTipoPersona, cp } = this.personaClientesForm.value;
  
    const isCommonInvalid = (nombre == null && this.valEditPerson) ||
                            (primerApellido == null && this.valEditPerson) ||
                            (razonSocial == null && !this.valEditPerson);
  
    if (this.esVentanilla) {
      return isCommonInvalid;
    } else {
      const isNonVentanillaInvalid = isCommonInvalid || idTipoPersona == null || cp == null;
      return isNonVentanillaInvalid;
    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async addPersonaClientes() {
    try {
      let aux = this.personaClientesForm.value.idTipoPersona;
      if (aux == "1") {
        this.personaClientesForm.patchValue({
          idTipoPersona: 1
        });
      }
      else {
        this.personaClientesForm.patchValue({
          idTipoPersona: 2
        });
      }

      if(!this.personaClientesForm.valid){throw new Error("Por favor, valide todos los campos con alerta antes de guardar.")}
     


      if (this.personaClientesForm.value.id == 0) {
        if (this.validateFormFields()) {
          this.muestraMensaje.error(
            "Ingresa los Campos Necesarios para crear un nuevo registro.",
            "top",
            "center"
          );
          return;
        }



        this.datosEnvia = this.personaClientesForm.value;

        // if (this.personaClientesForm.value.idColonia)
        //   this.datosEnvia.idColonia = this.personaClientesForm.value.idColonia.id;

        const datoretorno = await this.personaClientesService
          .add(this.datosEnvia)
          .toPromise();

        this.cuentasAguas.forEach(async (cuenta) => {
          cuenta.idPersona = datoretorno.id;
          //await this.addCuentasByPersona(cuenta);
        });

        await this.guardarGridCuentasByPersona();
        
        this.DatosPersonaClientesTable.slice(0);
        this.disableForm = true;
        this.disableSave = true;
        this.buscaPersonaClientes();

      } else {
        this.muestraMensaje.notification(
          "Ingresa los Campos Necesarios para crear un nuevo registro.",
          "top",
          "center"
        );
       // this.limpiaCasillas();
      }
    } catch (e) {
      this.muestraMensaje.error( e, "top",  "center" );
    } finally {
      console.log("Paso por addPersonaClientes");
    }
  }

  // asignaCatalogos() {
  //   if (this.personaClientesForm.value.idCalle)
  //     this.datosEnvia.idCalle = this.personaClientesForm.value.idCalle.id;
  //   if (this.personaClientesForm.value.idEstado)
  //     this.datosEnvia.idEstado = this.personaClientesForm.value.idEstado.id;
  //   if (this.personaClientesForm.value.idMunicipio)
  //     this.datosEnvia.idMunicipio = this.personaClientesForm.value.idMunicipio.id;
  //   if (this.personaClientesForm.value.idColonia)
  //     this.datosEnvia.idColonia = this.personaClientesForm.value.idColonia.id;
  // }

  async updatePersonaClientes() {
    try {
      this.personaClientesForm.patchValue({
        idDelegacion : this.auxDelegacion,
        idColonia: this.auxColonias,
        idCalle:this.auxCalle,
        idEntreCalle: this.auxEntreCalle
      });

      this.datosEnvia = this.personaClientesForm.value;
      if (this.datosEnvia.rfc === 'XAXX010101000' || this.datosEnvia.rfc === null) {
          this.datosEnvia.idRegimenFiscal = 12;
          this.datosEnvia.rfc = 'XAXX010101000';
      }
    

      if ( this.datosEnvia.idTipoPersona === 1 && (!this.datosEnvia.nombre || !this.datosEnvia.primerApellido))
        throw new Error ('El Nombre y/o Apellido paterno no pueden ir en blanco');
      
      if(this.datosEnvia.idTipoPersona === 2 && !this.datosEnvia.razonSocial)
        throw new Error ('La Razon Social no puede ir en blanco');
      if(this.datosEnvia.idRegimenFiscal== null)
        throw new Error ('El regimen fiscal debe ser seleccionado');
      //if(this.datosEnvia.idUsoCfdi == null)
        //throw new Error ('El Uso de CFDI debe ser seleccionado');
      if(!this.datosEnvia.cp)
        throw new Error ('El Codigo Postal no puede ir en blanco');
        
      if(!this.datosEnvia.rfc || this.datosEnvia.rfc.length < 0)
        this.datosEnvia.rfc = 'XAXX010101000'; 

      // if (this.personaClientesForm.value.idColonia)
      //  this.datosEnvia.idColonia = this.personaClientesForm.value.idColonia.id;

      const datoRetorno = await this.personaClientesService
        .update(this.datosEnvia)
        .toPromise();
      this.DatosPersonaClientesTable.splice(0);
      this.muestraMensaje.notification("DATOS GUARDADOS CORRECTAMENTE", "top", "center");
      this.valEdit = false;
      this.disableForm = true;
      await this.guardarGridCuentasByPersona();
      this.buscaPersonaClientes();
    } catch (e) {
      this.muestraMensaje.error(
        e,
        "top",
        "center"
      );
    } finally {
      console.log("Paso por updatePersonaClientes");
    }
  }


  

  async deletePersonaClientes(personaClientes) {
    try {
      await this.personaClientesService
        .delete(personaClientes.id)
        .toPromise();

      await this.buscaPersonaClientes();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deletePersonaClientes");
    }
  }

  async getPersonaClientes() {
    try {
      var id = this.personaClientesForm.value.id;
      const datoRetorno = await this.personaClientesService
        .getSingle(id)
        .toPromise();
      this.personaClientesForm.patchValue(datoRetorno);



    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getPersonaClientes");
    }
  }

  ngAfterViewInit() {
    this.initDatatable();
  }

  private initDatatable(): void {
    const tabla: any = $("#personaClientesTable");
    this.tableWidget = tabla.DataTable({
      scrollX: true,
      destroy: true,
      filter: false,
      language: {
        "sProcessing": "Procesando...",
        "sLengthMenu": "Mostrar _MENU_ registros",
        "sZeroRecords": "No se encontraron resultados",
        "sEmptyTable": "Ningún dato disponible en esta tabla",
        "sInfo": "Registros del _START_ al _END_ de un total de _TOTAL_ registros",
        "sInfoEmpty": "Registros del 0 al 0 de un total de 0 registros",
        "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
        "sInfoPostFix": "",
        "sSearch": "Buscar:",
        "sUrl": "",
        "sInfoThousands": ",",
        "sLoadingRecords": "Cargando...",
        "oPaginate": {
          "sFirst": "Primero",
          "sLast": "Último",
          "sNext": "Siguiente",
          "sPrevious": "Anterior"
        },
        "oAria": {
          "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
          "sSortDescending": ": Activar para ordenar la columna de manera descendente"
        },
        "buttons": {
          "copy": "Copiar",
          "colvis": "Visibilidad"
        }
      }
    });
  }
  private reInitDatatable(): void {
    this.tableWidget.destroy();
    // this.tableWidget = null;
    setTimeout(() => this.initDatatable(), 0);
  }

  async getAllPersonaClientes() {
    try {
      const datoRetorno = await this.personaClientesService
        .getAll()
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllPersonaClientes");
    }
  }

  async getAllCatEstados() {
    try {
      const datoRetorno = await this.catEstadosService.getAll().toPromise();
      this.catEstados = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstados");
    }
  }

  async getAllCatMunicipios() {
    try {
      const datoRetorno = await this.catMunicipiosService.getAll().toPromise();
      this.catMunicipios = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatMunicipios");
    }
  }

  async getAllCatColonias() {
    try {
      const datoRetorno = await this.catColoniasService.getAll().toPromise();
      this.catColonias = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatColonias");
    }
  }
   // cerr || 04042024 || se agrega metodo para cargar las delegaciones
   async getAllCatDelegaciones() {
    try {
      const datoRetorno = await this.catDelegacionesService.getAll().toPromise();
      this.catDelegaciones = datoRetorno;
      if(!datoRetorno) return;

      this.catDelegaciones.unshift({
        baja: null,
        cambio: null,
        id: 0,
        descripcion: 'SELECCIONA...',
        idMunicipio: null,
        numRow: null, });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por getCatDelegaciones ');
    }
  }


  async getAllCatCalles() {
    try {
      const datoRetorno = await this.catCallesService.getAll().toPromise();
      this.catCalles = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatCalles");
    }
  }

  async getAllCatTipoPersonas() {
    try {
      const datoRetorno = await this.catTipoPersonasService
        .getAll()
        .toPromise();
      this.catTipoPersonas = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoPersonas");
    }
  }


  checkCatValues(dropdown: Dropdown) {
    const item = dropdown.filterValue;
    let cancel = false;
    if (item != null && dropdown.placeholder == "Calle") {
      this.catCalles.forEach(e => {
        if (e.descripcion == item.toUpperCase()) {
          cancel = true;
        }
      });
    } else if (item != null && dropdown.placeholder == "Estado") {
      this.catEstados.forEach(e => {
        if (e.descripcion == item.toUpperCase()) {
          cancel = true;
        }
      });
    } else if (item != null && dropdown.placeholder == "Municipio") {
      this.catMunicipios.forEach(e => {
        if (e.descripcion == item.toUpperCase()) {
          cancel = true;
        }
      });
    } else if (item != null && dropdown.placeholder == "Colonia") {
      this.catColonias.forEach(e => {
        if (e.descripcion == item.toUpperCase()) {
          cancel = true;
        }
      });
    }

    if (item != null && cancel == false) {
      this.showDialogCat = true;
      this.valueToEdit = item.toUpperCase();
      this.catType = dropdown.placeholder;
    } else if (item != null && cancel != false) {
      this.muestraMensaje.error(
        "Registro ya Ingresado.",
        "top",
        "center"
      );
    }


    dropdown.resetFilter();
  }

  async addNewCat() {
    if (this.catType == "Calle") {
      let envia = {
        id: 0,
        descripcion: this.valueToEdit,
        baja: false,
        idColonia: null,
        numRow: null,
        cambio: false
      }
      const datoretorno = await this.catCallesService
        .add(envia)
        .toPromise();
      this.getAllCatCalles();

    } else if (this.catType == "Estado") {
      let envia = {
        id: 0,
        descripcion: this.valueToEdit,
        baja: false,
        numRow: null,
        cambio: false
      }
      const datoretorno = await this.catEstadosService
        .add(envia)
        .toPromise();
      this.getAllCatEstados();

    } else if (this.catType == "Municipio") {
      let envia = {
        baja: false,
        cambio: false,
        id: 0,
        idEstado: null,
        numRow: null,
        descripcion: this.valueToEdit
      }
      const datoretorno = await this.catMunicipiosService
        .add(envia)
        .toPromise();
      this.getAllCatMunicipios();

    } else if (this.catType == "Colonia") {
      let envia = {
        numRow: null,
        baja: false,
        cambio: false,
        id: 0,
        descripcion: this.valueToEdit,
        idZona: null,
        idDelagacion: null
      }
      const datoretorno = await this.catColoniasService
        .add(envia)
        .toPromise();
      this.getAllCatColonias();

    }
  }

  async cleanFilter(dropdown: Dropdown) {
    await dropdown.resetFilter();
  }

  async eliminarRFC(row){
    if(confirm("¿Deseas eliminar el registro?")) {
      this.deletePersonaClientes(row);
    }  
  }

  // cerr || 04042024 || se agrega filtro de colonia segun la delegacion seleccionada
  async selectCatDelegaciones(delegacion) {
    if(delegacion.value) 
      this.auxDelegacion = delegacion.value.id;
    else if(delegacion)
      this.auxDelegacion = delegacion.id;
    else
      return;
    const datoRetorno = await this.catColoniasService.getSingleDelegacion(this.auxDelegacion).toPromise();
      this.catColonias = datoRetorno;
  }

  // cerr || 04042024 || se agrega filtro de calles segun la colonia seleccionada
  async selectOPtionA(colonias) {
    if(colonias.value) 
      this.auxColonias = colonias.value.id;
    else if(colonias)
      this.auxColonias = colonias.id;
    else
      return;
    
    this.personaClientesForm.patchValue({
      idColonia: this.auxColonias
    });
    debugger;
    if (this.auxColonias) {
      const datoRetorno = await this.catCallesService.getSingleColonias(this.auxColonias).toPromise();
      this.catCalles = datoRetorno;
    }    
  }

  // se agrega regreso del drop para agarrar la descripcion de la calle
  async selectCatCalles(calle) { 
    if(calle.value) 
      this.auxCalle = calle.value.id;
    else if(calle)
      this.auxCalle = calle.id;
    else
      return;
    
    this.personaClientesForm.patchValue({
      idCalle: this.auxCalle
    });
  }

  async selectCatEntreCalles(calle) { 
    if(calle.value) 
      this.auxEntreCalle = calle.value.id;
    else if(calle)
      this.auxEntreCalle = calle.id;
    else
      return;
    
    this.personaClientesForm.patchValue({
      idEntreCalle: this.auxEntreCalle
    });
  }
  async selectCatYCalles(calle) { 
    if(calle.value) 
      this.auxYCalle = calle.value.id;
    else if(calle)
      this.auxYCalle = calle.id;
    else
      return;
    
    this.personaClientesForm.patchValue({
      idYCalle: this.auxYCalle
    });
  }




  validarRFC(control: FormControl): { [s: string]: boolean } {
    if(!control.value) {return null;}
    const rfcPatternPersonaFisica = /^[a-zA-Z]{4}\d{6}[a-zA-Z0-9]{3}$/;
    const rfcPatternPersonaMoral = /^[a-zA-Z]{3}\d{6}[a-zA-Z0-9]{3}$/;
    
    const value = control.value.toUpperCase();

    if (!rfcPatternPersonaFisica.test(value) && !rfcPatternPersonaMoral.test(value)) {
      return { 'invalidRFC': true };
    }

    return null;
  }


}
